import { ApplicationsState } from '@/state'
import { applicationsStateActions } from '@/state/actions'
import { Input } from 'antd'

export default function ApplicationsTextFilter() {
  return (
    <Input.Search
      className='text-filter'
      allowClear
      onSearch={applicationsStateActions.setApplicationTextFilter}
      placeholder='Filtro por texto'
      disabled={ApplicationsState.loading.value.getAll}
    />
  )
}
